export default {"src":"/_next/static/media/ic-clear-light.b1c8bc97.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};